import { useState, useEffect, useCallback, useMemo } from "react";
import { Link, Redirect, useHistory, useLocation } from "react-router-dom";
import { Flex, Box } from "rebass/styled-components";
import styled from "styled-components";
import { HiOutlineX } from "react-icons/hi";
import { useRecoilState } from "recoil";
import Axios from "axios";

import { ProfileSideRailUserInfo } from "./Components/ProfileSideRailUserInfo";
import {
  Page,
  MainRail,
  StickySideRail,
  Modal,
  PaddedWrapper,
} from "../../Components/Wrappers";
import { Error } from "../../../components/atoms/form/error";
import { ShareModal } from "../../../components/organisms/modalContents/share";
import { FooterLinks } from "../../../components/organisms/footerLinks";
import { isDotaPartner, isLeaguePartner } from "../../../utils";
import BackgroundImageProfile from "../../../assets/images/backgrounds/profileBG.jpg";
import { getQueryParam } from "../../Utilities/QueryParam";
import { ClipFeed } from "../../Components/ClipFeed";
import { Header } from "./Components/Header";
import { MobileClips } from "./Components/MobileClips";
import {
  ECrossSitePromotionType,
  ESupportedGames,
  IClipsQueryGQL,
  ModalType,
  TPaginatedClipFeed,
} from "../../@types";
import { ProfileViewModel } from "./ViewModel";
import { CLIP_STATUS } from "../../Utilities/Clip";
import { ClipsTypeSelector } from "../../Components/ClipsTypeSelector";
import { useIsDesktopApp } from "../../Hooks/useIsDesktopApp";
import { CrossSitePromotion } from "../CrossSitePromotion";
import { Divider } from "../../Components/Divider";
import { AllstarModalState } from "../../State/modals";
import { TSortTypes } from "../../Components/Pinnable/@types";
import { EClipsViews } from "../../@types";
import { ISetClipInactiveProps } from "../../Components/Clip/@types";
import { MobileAppAd } from "../../Components/MobileAppAd";
import { useLoginModal } from "MVVM/Hooks/useLoginModal";
import { FilterRowContainer } from "MVVM/Views/Filters";
import { IOption } from "MVVM/Views/Filters/components/index";
import { ProfileClips } from "MVVM/Views/Profile/Clips";
import { ProfileSkeleton } from "./ProfileSkeleton";
import { useFiltersFromUrl } from "MVVM/Hooks/useFiltersFromUrl";
import Leaderboard from "../Competitions/Components/Leaderboard";
import { LeaderboardWidget } from "../Competitions/Components/LeaderboardWidget";

//Need to reimplement
function getDefaultGame(userQuery: string) {
  if (isDotaPartner(userQuery)) return ESupportedGames.DOTA2;
  if (isLeaguePartner(userQuery)) return ESupportedGames.LOL;

  if (
    Object.values(ESupportedGames).includes(
      Number(getQueryParam("game")) as ESupportedGames,
    )
  ) {
    return Number(getQueryParam("game")) as ESupportedGames;
  }

  return ESupportedGames.ALL;
}

export default function (props: any) {
  const history = useHistory();
  const isDesktopApp = useIsDesktopApp();
  const location: Record<string, any> = useLocation();
  const params = new URLSearchParams(history.location.search);
  const userQuery = getQueryParam("user") || props.match.params.user;
  const viewQuery = getQueryParam("view") || EClipsViews.Clips;
  const [game, setGame] = useState<any>(getDefaultGame(userQuery));

  const [allstarModalState, setAllstarModalState] =
    useRecoilState(AllstarModalState);
  const [loadingDataSet, setLoadingDataSet] = useState<boolean>(false);

  const setFollowModal = ({ displayName, avatar }: any) => {
    setAllstarModalState({
      ...allstarModalState,
      isOpen: ModalType.Signup,
      data: {
        target: displayName,
        avatar: avatar,
        action: "follow",
      },
    });
  };
  /*  Pagination state */
  const [hasMoreData, setHasMoreData] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [view, setView] = useState(() => {
    if (Object.values(EClipsViews).includes(viewQuery as EClipsViews)) {
      return viewQuery as EClipsViews;
    }
    return EClipsViews.Clips;
  });
  // const isMontage = view === EClipsViews.Montages;
  const [clipInfiniteList, setClipInfiniteList] =
    useState<TPaginatedClipFeed | null>(null);
  const [clipList, setClipList] = useState<any[]>([]);
  const [sortedBy, setSortedBy] = useState<TSortTypes>("createdDate");
  const [query, setQuery] = useState<IClipsQueryGQL | null>(() => {
    const baseQuery = {
      search: sortedBy,
      game: Number(game),
      page,
      followers: false,
      mobile: false,
    };

    return baseQuery;
  });

  const {
    ready,
    fromRemix,
    clearViewModelState,
    fatalError,
    clips,
    allstarUser,
    mutateFollowers,
    fetchFilters,
    filterData,
    filterLoading,
    filterError,
    userClipsRefetch,
    userLoading,
    userError,
    user,
    userData,
    userNetworkStatus,
    pageInfo,
    handleFetchWithFilters,
  } = ProfileViewModel(
    userQuery,
    location.state,
    view,
    game,
    !!props.match.params.user,
  );


  const {
    filters: selectedFilters,
    setFilters: setSelectedFilters,
    updateUrl,
  } = useFiltersFromUrl();

  const { portalOpen, Portal } = useLoginModal(allstarUser);

  const viewToQueryProperty: any = useMemo(() => ({
    [EClipsViews.Mobile]: {
      mobile: true,
      followers: false,
      search: sortedBy,
      game: game,
      user: user?.userId,
    },
    [EClipsViews.Following]: {
      followers: true,
      mobile: false,
      search: sortedBy,
      game: game,
      page: 1,
      user: user?.userId,
    },
    [EClipsViews.Clips]: { followers: false, mobile: false },
    [EClipsViews.Montages]: {
      page: 1,
      user: user?.userId,
      game: game,
    },
  }), [sortedBy, game, user?.userId]);

  const [isShareModalOpen, setShareModalOpen] = useState(
    location?.state?.fromEdit,
  );
  const [mobileNotice, setMobileNotice] = useState(
    location?.state?.queuedMobile,
  );

  const ClipsFeedRequest = useCallback(async (page: number, force?: boolean) => {
    if (!force) {
      if (!user || loadingDataSet) return;
    }

    setLoadingDataSet(true);

    const { error, data } = await clips.ClipsFeed({
      variables: {
        ...query,
        page,
        user: user.userId,
        ...viewToQueryProperty[view],
      },
    });

    if (error) {
      console.log(`ClipsFeed error! ${error.message}`);
      return;
    }
    const reqData: TPaginatedClipFeed = data.clips ?? data.montages;

    if (!reqData) {
      setHasMoreData(false);
      setLoadingDataSet(false);
      return;
    }

    if (!clipInfiniteList) {
      setClipInfiniteList(reqData);
      setClipList((existingList) => [...existingList, ...reqData.data]);
      setHasMoreData(reqData.data.length > 9);
      setLoadingDataSet(false);
      return;
    }

    if (reqData.currentPage === clipInfiniteList.currentPage) {
      // this happens cause a reload of clipList triggers but the same data is returned.
      setLoadingDataSet(false);
      return true;
    }

    setClipInfiniteList(reqData);
    setHasMoreData(reqData.data.length > 9);
    setClipList((existingList) => [...existingList, ...reqData.data]);
    setLoadingDataSet(false);
  }, [user, loadingDataSet, clips.ClipsFeed, query, view, viewToQueryProperty]);

  useEffect(() => {
    if (ready && user) {
      ClipsFeedRequest(page);
    }
  }, [page, user?.userId, ready]);

  const paginationClips = (): void => {
    if (!clipInfiniteList || !hasMoreData) return;

    setPage(page + 1);
    return;
  };

  const setClipInactive = async ({
    id,
    isMontage,
    deleteMobile,
  }: ISetClipInactiveProps) => {
    const reloadClips = () => {
      setClipInfiniteList(null);
      setClipList([]);
      setPage(1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

    if (isMontage) {
      await clips.deleteMontage({
        variables: { montageIdentifier: id },
      });
      reloadClips();
      return { data: { status: "ok" } };
    } else {
      const BASE_URL = process.env.REACT_APP_API_URL;
      const opt: any = {
        method: "PATCH",
        url: `${BASE_URL}/items/clips?token=${allstarUser.token}`,
        data: {
          _id: id,
          status: CLIP_STATUS.INACTIVE,
          deleteMobile: deleteMobile,
        },
      };

      let response;
      try {
        response = await Axios(opt);
        reloadClips();
        if (view === EClipsViews.Clips) handleFetchWithFilters(selectedFilters);
      } catch (e) {}

      return response;
    }
  };

  const onQuery = async (
    updatedValue: boolean | string | string[] | number | null,
    indentifier: "search" | "status" | "filter" | "remixes" | "game",
  ): Promise<any> => {
    if (!query) return;

    setClipList([]);
    setClipInfiniteList(null);

    let queryUpdate = {
      ...query,
    };
    // Remove query:

    if (queryUpdate[indentifier] === updatedValue) {
      // console.log(query[indentifier], " exists");
      delete queryUpdate[indentifier];
    } else {
      // Add query:
      queryUpdate = {
        ...queryUpdate,
        [indentifier]: updatedValue,
      };
    }

    queryToUrl(queryUpdate);
    setQuery({ ...queryUpdate });
    return clips.refetchClipsFeed(queryUpdate);
  };

  //This triggers a refetch!
  const clearLocalState = () => {
    setClipList([]);
    setClipInfiniteList(null);
    setQuery({ search: sortedBy, game: game, page });
    setPage(1);
    setLoadingDataSet(false);
  };

  useEffect(() => {
    if (!user) return;
    // This reloads profiles from the profile page.

    if (
      userQuery &&
      user?.username?.toLowerCase() !== userQuery.toLowerCase() &&
      user?.userId !== userQuery
    ) {
      clearLocalState();
      return clearViewModelState(userQuery);
    }

    if (
      user.username &&
      (user?.username !== userQuery || user?.userId !== userQuery)
    ) {
      // this handles maintaining the query string when resolving to a /u/ route
      params.delete("user");
      const replaceParams = params.toString() ? `?${params.toString()}` : "";
      window.history.replaceState(
        null,
        "",
        `/u/${user.username}${replaceParams}`,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, userQuery]);

  const queryToUrl = async (query: IClipsQueryGQL) => {
    let queryString = "";
    const arrayOfParam = [];
    if (isDesktopApp.isDesktop) {
      arrayOfParam.push("external=desktopapp");
    }
    if (query.game) {
      arrayOfParam.push(`game=${query.game}`);
    }
    if (view) {
      arrayOfParam.push(`view=${view}`);
    }

    if (arrayOfParam.length) queryString = `?${arrayOfParam.join("&")}`;
    // add to window:

    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}${queryString}`,
    );
  };

  const handleViewChange = (tabView: EClipsViews): void => {
    if (tabView !== view && query) {
      const queryUpdate = {
        ...query,
      };

      let append = "";
      if (isDesktopApp.isDesktop) {
        append = "&external=desktopapp";
      }

      history.replace(
        `${
          user.username
            ? `/u/${user.username}?view=${tabView}${append}`
            : `/profile?user=${user.userId}&view=${tabView}${append}`
        }`,
      );

      setQuery({ ...queryUpdate, game: 0 });
      setClipList([]);
      setClipInfiniteList(null);
      setLoadingDataSet(false);
      setPage(1);
      setView(tabView);
      setGame(ESupportedGames.ALL);
    }
  };

  const followUnfollow = (data: any): void => {
    mutateFollowers(data);
    return;
  };

  const mutateReaction = (data: any): void => {
    // Its faster here than in component...
    clips.mutateReaction(data);
    return;
  };

  const sortClips = (sort: TSortTypes) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setPage(1);
    setClipList([]);
    setClipInfiniteList(null);
    setLoadingDataSet(false);
    setSortedBy(sort);
    onQuery(sort, "search");
  };

  const filterGame = (game: number | string | null) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setPage(1);
    setClipList([]);
    setClipInfiniteList(null);
    setLoadingDataSet(false);
    setGame(game);
    onQuery(game, "game");
  };

  const handleFilterChange = (option: IOption, filterKey: string) => {
    setSelectedFilters((prev) => {
      const updatedFilters = { ...prev };

      if (!option.value) {
        delete updatedFilters[filterKey];
      } else {
        const currentValues = updatedFilters[filterKey] || [];
        const newValues = currentValues.includes(option.value)
          ? currentValues.filter((val) => val !== option.value)
          : [...currentValues, option.value];

        if (newValues.length) {
          updatedFilters[filterKey] = newValues;
        } else {
          delete updatedFilters[filterKey];
        }
      }

      updateUrl(updatedFilters);
      handleFetchWithFilters(updatedFilters);
      return updatedFilters;
    });
  };

  const handleResetToAllGames = async (): Promise<void> => {
    filterGame(ESupportedGames.ALL);
    setSelectedFilters({});
  };

  if (fatalError) {
    const [, redirect] = fatalError;

    return <Redirect to={redirect} />;
  }

  if (!ready) return <ProfileSkeleton />;

  return (
    <>
      {portalOpen && Portal}
      <StyleProfile flexDirection="column" mb={6}>
        {mobileNotice ? (
          <PaddedWrapper>
            <Flex width="100%" paddingBottom={"15px"}>
              <Error
                width="100%"
                type="notify"
                style={{ position: "relative" }}
                remove={
                  <>
                    <RemoveWrapper
                      onClick={() => {
                        setMobileNotice(false);
                      }}
                    >
                      <StyledX size="23px" />
                    </RemoveWrapper>
                  </>
                }
              >
                Your{" "}
                <Link
                  to="/profile?view=mobile"
                  style={{ color: "#e69771", textDecoration: "none" }}
                  onClick={() => {
                    setMobileNotice(false);
                  }}
                >
                  mobile
                </Link>{" "}
                clip is being generated. It will be available in a few moments.
              </Error>
            </Flex>
          </PaddedWrapper>
        ) : (
          <></>
        )}
        <Header
          allstarUser={allstarUser}
          loading={!ready}
          user={user}
          followUnfollow={followUnfollow}
          isDesktop={isDesktopApp.isDesktop}
        />
      </StyleProfile>

      <StyledPage isDesktop={isDesktopApp.isDesktop}>
        <Flex flexDirection={"column"} flexBasis={1350}>
          <ClipsTypeSelector
            isProfile={true}
            handleViewChange={handleViewChange}
            view={view}
          />
          <Flex justifyContent={"space-between"} flexDirection={"row"} mb={5}>
            {![
              EClipsViews.Montages,
              EClipsViews.Mobile,
              EClipsViews.Following,
            ].includes(view) && (
              <FilterRowContainer
                filterGame={filterGame}
                game={game}
                handleFilterChange={handleFilterChange}
                fetchFilters={fetchFilters}
                filterData={filterData}
                filterLoading={filterLoading}
                filterError={filterError}
                handleResetToAllGames={handleResetToAllGames}
                selectedFilters={selectedFilters}
              />
            )}
          </Flex>

          <MainRail>
            {view === EClipsViews.Mobile ? (
              <MobileClips
                clipList={clipList}
                loading={clips.loading}
                hasMoreData={hasMoreData}
                paginationClips={paginationClips}
                refresh={ClipsFeedRequest}
                user={user}
                view={view}
              />
            ) : view === EClipsViews.Clips ? (
              <ProfileClips
                isOwnProfile={user?.isOwnProfile}
                view={view}
                user={user}
                userData={userData}
                userLoading={userLoading}
                userError={userError}
                userNetworkStatus={userNetworkStatus}
                pageInfo={pageInfo}
                paginationClipsNew={userClipsRefetch}
                setClipInactive={setClipInactive}
                hasFiltersSelected={!!Object.keys(selectedFilters).length}
              />
            ) : (
              <>
                <ClipFeed
                  allstarUser={allstarUser}
                  fromRemix={fromRemix}
                  user={user}
                  game={query?.game!}
                  query={query!}
                  onQuery={onQuery}
                  sortedBy={sortedBy}
                  setSortedBy={setSortedBy}
                  hasMoreData={hasMoreData}
                  loading={clips.loading}
                  paginationClips={paginationClips}
                  clips={clipList}
                  mutateReaction={mutateReaction}
                  followUnfollow={followUnfollow}
                  setFollowModal={setFollowModal}
                  isProfile={true}
                  setClipInactive={setClipInactive}
                  view={view}
                  isOwnProfile={user?.isOwnProfile}
                />
              </>
            )}
          </MainRail>
        </Flex>
        {!isDesktopApp.isDesktop && (
          <StickySideRail showOnMobile={false} display={"flex"}>
            <ProfileSideRailUserInfo
              country={user?.country}
              joinDate={user?.joinDate}
              stats={user?.stats}
              socials={user?.socials}
              isOwnProfile={user?.isOwnProfile}
            />
            <LeaderboardWidget />
            <MobileAppAd />
            <CrossSitePromotion type={ECrossSitePromotionType.SideRailAd} />
            <Divider width="100%" pl={4} pr={4}></Divider>
            <FooterLinks />
          </StickySideRail>
        )}
      </StyledPage>

      <Modal
        isModalOpen={!!isShareModalOpen}
        setModalOpen={setShareModalOpen}
        handleModalClose={undefined}
        disableOutsideClose={undefined}
      >
        <ShareModal clip={isShareModalOpen} isMobile={false}></ShareModal>
      </Modal>
    </>
  );
}

const StyleProfile = styled(Flex)`
  background: rgb(24, 37, 45);
  background-position: 0px;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${BackgroundImageProfile});

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    background-size: cover;
    background-position: center;
  }
`;

const StyledX = styled(HiOutlineX)`
  color: ${(props) => {
    return props.theme.colors.chalk;
  }};
  &:hover {
    cursor: pointer;
    color: ${(props) => {
      return props.theme.colors.midnight;
    }};
  }
`;

const RemoveWrapper = styled(Box)`
  position: absolute;
  right: 8px;
  top: 10px;
`;

const StyledPage = styled(Page)`
  @media (max-width: ${(props) => props.theme.breakpoints[3]}) {
    padding-left: 20px;
  }
`;
